import { useMemo, useState } from 'react';

import { PAGINATION_OPTIONS } from '@/shared/lib/constants';

import type { PaginationConfig } from './types';

export const useQualityPaginationConfig = (total: number) => {
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);

  const paginationConfig: PaginationConfig = useMemo(
    () => ({
      current: page,
      pageSize,
      pageSizeOptions: [...PAGINATION_OPTIONS],
      showSizeChanger: true,
      total,
      locale: { items_per_page: '' },
      showTotal: (total: number, range: [number, number]) => `(${total}개 중 ${range[0]}-${range[1]})`,
      onChange: (newPage: number, newPageSize: number) => {
        setPage(newPage);
        setPageSize(newPageSize);
      },
    }),
    [page, pageSize, total]
  );

  return { page, pageSize, paginationConfig };
};
